import { getMealTypeGroupKey } from 'helpers/mealTypeGroupKeys';

// Keys used to match meals when a quick filter is applied.
// Prefer productTypeNames (stable) over display labels when configured.
export const getQuickFilterMatchValues = quickFilter => {
  if (quickFilter.productTypeNames?.length) {
    return quickFilter.productTypeNames;
  }

  if (quickFilter.filterValues?.length) {
    return quickFilter.filterValues;
  }

  return [quickFilter.filterValue].filter(Boolean);
};

// Values written into meal filter state when a quick filter is selected.
// Meal type filters also set a group key so the slideout checkbox stays in sync
// and overlapping options remain independently selected.
export const getQuickFilterSelectionValues = quickFilter => {
  const matchValues = getQuickFilterMatchValues(quickFilter);
  if (quickFilter.filterName !== 'mealType') return matchValues;

  return [getMealTypeGroupKey(quickFilter.displayName), ...matchValues];
};
